/* Packages */
import React from "react";
import SimpleValue from "@webstores/webstores-configurator/dist/inputs/abstracts/SimpleValue";
import { DebounceInput } from "react-debounce-input";

export default function TextField({
    stepData,
    setStepData,
    input,
    field,
    preventUpdate = true,
    formatNumber = false,
    ...rest
}) {
    /* Functions */
    const getFormatedValue = () => {
        return new Intl.NumberFormat("nl-NL").format(parseInt(input.value));
    };

    /* Render */
    return (
        <SimpleValue
            input={input}
            stepData={stepData}
            setStepData={setStepData}
            preventUpdate={preventUpdate}
            field={field}>
            {({ updateValue }) => {
                return (
                    <DebounceInput
                        {...input}
                        {...rest}
                        value={formatNumber ? getFormatedValue() : input.value}
                        debounceTimeout={750}
                        onChange={(e) => {
                            updateValue(e.target.value);
                        }}
                    />
                );
            }}
        </SimpleValue>
    );
}
